var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"language-switcher flags"},_vm._l((_vm.languages),function(lang){return _c('a',{key:lang,attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.setLanguage(lang)}}},[_c('img',{attrs:{"src":_vm.flag(lang)}})])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63c37a9f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/snippets/language-switcher.vue
// module id = 0GqW
// module chunks = 32